import { html, render } from "lit-html";
import confetti from "canvas-confetti";
import { animateCSS } from "./util/animateCSS";
import { wait } from "./util/wait";

function setUp(): void {
  // Declare a template
  const template = html`<div class="dev-toast">
    <div>Du bist jetzt Entwickler*in 🎉</div>
  </div>`;
  const logo = document.querySelector("#footer-logo") as HTMLElement;
  if (logo == null) {
    return;
  }
  let clickCount = 0;
  let timer: number | undefined = undefined;
  const listener = (): void => {
    clickCount++;
    if (clickCount === 1) {
      logo.style.cursor = "pointer";
      timer = window.setTimeout(() => {
        clickCount = 0;
        logo.style.cursor = "default";
      }, 5000);
    }
    if (clickCount === 7) {
      window.clearTimeout(timer);
      logo.removeEventListener("click", listener);
      const target = document.createElement("div");
      document.body.appendChild(target);
      render(template, target);
      const toast = target.firstElementChild;
      if (toast == null) {
        return;
      }
      Promise.all([
        animateCSS(toast, "tada"),
        confetti({ particleCount: 100, spread: 70, origin: { y: 0.9 }, disableForReducedMotion: true }),
      ])
        .then(() => wait(5000))
        .then(() => animateCSS(toast, "zoomOut"))
        .then(() => {
          logo.style.cursor = "default";
          target.remove();
        });
    }
  };

  logo.addEventListener("click", listener);
}
setUp();
